import StudentGuidanceDeleteModal from "./StudentGuidanceDeleteModal";

export default StudentGuidanceDeleteModal;

